import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-home-right',
  templateUrl: './home-right.component.html',
  styleUrls: ['./home-right.component.scss']
})
export class HomeRightComponent implements OnInit, OnDestroy {
  public server: string = this.serverService.get_server();
  public server_main: string = this.serverService.get_server_main();
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public dir: any = JSON.parse(<any>localStorage.getItem('dir'));
  public no_record: string = this.serverService.no_record();
  public loading: boolean = false;
  public show_chart: boolean = false;
  public show_group: boolean = false;
  public my_network: boolean = false;
  public show_record: boolean = false;
  public report_users: boolean = false;
  public loading2: boolean = false;
  public netwok: string = "profit";
  public count_bascket_status_all: number = 0;
  public code_bascket: number = 0;
  public type: number = 1;
  public list_content: any = [];
  public list_rstatus: any = [];
  public list_repairman: any = [];
  public list_groups: any = [];
  public list_bascket_status: any = [];
  public list_report_users: any = [];
  public subscription: Subscription | any;
  public report!: string;
  public rstatus_report_id!: number;
  public moarf!: string;
  public user_id!: number;
  public user!: number;
  public rstatus_id!: number;
  public groups_id!: number;
  public bascket_status_id!: number;
  public level!: number;
  public creator!: number;
  public group_id!: number;
  public bascket_status!: number;
  public record_id!: any;

  constructor(
    public router: Router,
    public serverService: ServerService,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public http: HttpClient,
    public activatedRoute: ActivatedRoute,
    public messageService: MessageService
    , @Inject(DOCUMENT) public document: any
  ) {
    this.serverService.get_bascket_status().subscribe(
      (res) => {
        if (res) {
          this.code_bascket = res.code_bascket;
          this.bascket_status_id = res.bascket_status_id;
          this.get_bascket_status(res.code_bascket, res.bascket_status_id);
        }
      }
    )
    this.serverService.get_my_network().subscribe(
      (res) => {
        this.set_false();
        this.netwok = 'profit';
        this.my_network = true;
      }
    )
    this.serverService.get_report_users().subscribe(
      (res) => {
        this.set_false();
        this.get_report_users();
      }
    )
    this.serverService.get_reception_rstatus().subscribe(
      (res) => {
        if (this.list_rstatus.length == 0 || res.alter == true) {
          this.level = res.level;
          this.get_rstatus();
        }
        this.rstatus_id = res.rstatus_id;
      }
    )
    this.serverService.get_group().subscribe(
      () => {
        //this.get_groups();
        this.set_false();
      }
    )
    this.serverService.get_reset().subscribe(
      () => {
        this.set_false();
      }
    )
  }
  set_false() {
    this.show_record = false;
    this.my_network = false;
    this.show_group = false;
    this.report_users = false;
    this.report = '';
    this.list_groups = [];
    this.list_rstatus = [];
    this.list_repairman = [];
    this.list_bascket_status = [];
    this.list_groups = [];
  }
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.get_logo();
  }
  get_logo() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1038, user_id: this.user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.level = res['level'];
          this.creator = res['creator'];
          this.level = res['level'];
        }//end if
        else {
          this.serverService.signout();
        }
      }
    )
  }
  //*********************************************************************************************************************** */
  get_moarf(type: string) {
    this.groups_id = 0;
    this.moarf = type;
    this.router.navigate(['/home/user/161'], { queryParams: { moarf: type } });
  }
  //********************************************************************************************************************** */
  get_report_users() {
    this.show_record = true;
    this.report_users = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6900, user_id: this.user_id, creator: this.creator }).subscribe(
      (res: any) => {
        this.list_report_users = [];
        this.record_id = 'all';
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_report_users.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_filter_report_users(type: string) {
    this.record_id = type;
    this.router.navigate(['/home/user/261'], { queryParams: { reportUsers: type } });
  }
  //*********************************************************************************************************************** */
  get_groups() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6137, user_id: this.user_id, creator: this.creator }).subscribe(
      (res: any) => {
        this.show_record = true;
        this.show_group = true;
        this.my_network = false;
        this.list_groups = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_groups.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  go_to_group(id: number) {
    this.moarf = '';
    this.groups_id = id;
    this.router.navigate(['/home/user/161'], { queryParams: { id: id } });
  }
  get_my_consume_in_netwok() {
    this.netwok = 'consume';
    this.router.navigate(['/home/charge/232'], { queryParams: { type: 'account', typeCharge: 2 } });
  }
  get_my_netwok() {
    this.netwok = 'profit';
    this.router.navigate(['/home/network/253'], { queryParams: { type: 'account' } });
  }
  //*********************************************************************************************************************** */
  change_rstatus(status: string) {
    this.report = status;
    if (status == 'repairman') {
      this.get_repairman();
    }
  }
  change_show_chart() {
    this.show_chart = !this.show_chart;
  }
  get_rstatus() {
    var obj = {
      address: 1682,
      user_id: this.user_id,
      creator: this.creator,
      level: this.level,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.show_record = true;
        this.list_rstatus = [];
        this.report = 'rstatus';
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].repairman_rstatus_logo) {
              res['result'][i].logo = res['result'][i].repairman_rstatus_site_logo + "/" + res['result'][i].repairman_rstatus_logo;
            } else {
              res['result'][i].logo = this.serverService.get_default_image();
            }
            this.list_rstatus.push(res['result'][i]);
          }//end for
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  go_to_reception_with_rstatus(rstatus: number) {
    this.rstatus_id = rstatus;
    this.router.navigate(['/home/reception/170'], { queryParams: { rstatus: rstatus, pos: 'right' } });
  }
  //******************************************************************************************************** */
  get_repairman() {
    var obj = {
      address: 6815,
      creator: this.creator
    }
    this.loading2 = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.show_record = true;
        this.list_repairman = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_repairman.push(res['result'][i]);
          }//end for
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  go_to_reception_with_repairman(user: number) {
    this.record_id = user;
    this.router.navigate(['/home/reception/197'], { queryParams: { repairman: user } });
    this.serverService.send_reset_services_id('');
  }
  //*********************************************************************************************************************** */
  get_bascket_status(code: number, bascket_status: number) {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { address: 6366, code: code, lang: this.lang }).subscribe(
      (res: any) => {
        this.bascket_status = bascket_status;
        this.show_record = true;
        this.my_network = false;
        this.count_bascket_status_all = 0;
        this.list_bascket_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].bascket_status_success == 1) {
              this.count_bascket_status_all += res['result'][i].count;
            }

            this.list_bascket_status.push(res['result'][i]);
          }//end for
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //************************************************************************************* */
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
      this.loading2 = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //************************************************************************************
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }

}
